import { render, staticRenderFns } from "./OlderDetailAddBase.vue?vue&type=template&id=41401e08&scoped=true"
import script from "./OlderDetailAddBase.vue?vue&type=script&lang=js"
export * from "./OlderDetailAddBase.vue?vue&type=script&lang=js"
import style0 from "./OlderDetailAddBase.vue?vue&type=style&index=0&id=41401e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41401e08",
  null
  
)

export default component.exports